import { Loader2Icon } from "lucide-react";
import type { ComponentProps } from "react";

import { cn } from "@/utils/cn";

function Spinner({ className, ...props }: ComponentProps<typeof Loader2Icon>) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
